import { combineReducers } from 'redux';

import status from './status/reducers';
import tasks from './tasks/reducers';

const requestTasksReducer = combineReducers({
  status,
  tasks,
});

export default requestTasksReducer;
